// extracted by mini-css-extract-plugin
export default {"accordionContent":"DeliverablesPhasesList_accordionContent__GA-Rp","line":"DeliverablesPhasesList_line__2Bd6k font-sm-medium"};